module.exports = __webpack_public_path__ + "img/New Project (6).a162bcbc.png";